<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
    </v-breadcrumbs>
    <!-- <v-card style="border-radius: 15px"
            class="mx-16"> -->
    <v-row dense
           class="d-flex justify-center mx-16 v-step-0">
      <v-col cols="5"
             class="mt-2">
        <v-combobox v-model="gene_select"
                    dense
                    clearable
                    clear-icon="mdi-close-circle"
                    :loading="gene_loading"
                    :items="gene_items"
                    :search-input.sync="gene_search"
                    outlined
                    rounded
                    label="Gene Name"
                    :messages="gene_message"
                    :error-messages="gene_error_message"
                    :disabled="is_disable_gene">
        </v-combobox>
      </v-col>
      <v-col cols="5"
             class="mt-2">
        <v-select v-model="project_select"
                  outlined
                  rounded
                  dense
                  clearable
                  clear-icon="mdi-close-circle"
                  label="TCGA Project ID"
                  :items="project_items"
                  :error-messages="project_error_message"
                  :disabled="is_disable_project">
        </v-select>
      </v-col>
      <v-col cols="1"
             sm="1"
             md="1"
             xl="1"
             class="mt-2">
        <v-dialog v-model="dialog"
                  :retain-focus="false">
          <template v-slot:activator="{  }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color=""
                       icon
                       @click="dialog=true"
                       v-bind="attrs"
                       v-on="on">
                  <v-icon>mdi-help-circle</v-icon>
                </v-btn>
              </template>
              <span>Click here to get the extension of tumor abbreviations.</span>
            </v-tooltip>
          </template>
          <v-card style="left:25%; width:50%">
            <v-card-title class="font-weight-bold grey lighten-2"
                          style="padding:0px 0px 0px 20px">
              TCGA Project ID - Project Name
              <v-spacer></v-spacer>
              <v-btn icon
                     large
                     @click="dialog = false">
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-simple-table dense
                            fixed-header
                            height="600px">
              <template v-slot:default>
                <thead class="font-weight-bold">
                  <tr>
                    <th class="text-left"
                        style="width:30%">Project ID</th>
                    <th class="text-left"
                        style="width:70%">Project Name</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>TCGA-ACC</td>
                    <td>Adrenocortical Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-BLCA</td>
                    <td>Bladder Urothelial Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-BRCA</td>
                    <td>Breast Invasive Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-CESC</td>
                    <td>Cervical Squamous Cell Carcinoma and Endocervical Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-CHOL</td>
                    <td>Cholangiocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-COAD</td>
                    <td>Colon Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-DLBC</td>
                    <td>Lymphoid Neoplasm Diffuse Large B-cell Lymphoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-ESCA</td>
                    <td>Esophageal Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-GBM</td>
                    <td>Glioblastoma Multiforme</td>
                  </tr>
                  <tr>
                    <td>TCGA-HNSC</td>
                    <td>Head and Neck Squamous Cell Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-KICH</td>
                    <td>Kidney Chromophobe</td>
                  </tr>
                  <tr>
                    <td>TCGA-KIRC</td>
                    <td>Kidney Renal Clear Cell Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-KIRP</td>
                    <td>Kidney Renal Papillary Cell Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-LGG</td>
                    <td>Brain Lower Grade Glioma</td>
                  </tr>
                  <tr>
                    <td>TCGA-LIHC</td>
                    <td>Liver Hepatocellular Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-LUAD</td>
                    <td>Lung Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-LUSC</td>
                    <td>Lung Squamous Cell Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-MESO</td>
                    <td>Mesothelioma</td>
                  </tr>
                  <tr>
                    <td>TCGA-OV</td>
                    <td>Ovarian Serous Cystadenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-PAAD</td>
                    <td>Pancreatic Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-PCPG</td>
                    <td>Pheochromocytoma and Paraganglioma</td>
                  </tr>
                  <tr>
                    <td>TCGA-PRAD</td>
                    <td>Prostate Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-READ</td>
                    <td>Rectum Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-SARC</td>
                    <td>Sarcoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-SKCM</td>
                    <td>Skin Cutaneous Melanoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-STAD</td>
                    <td>Stomach Adenocarcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-TGCT</td>
                    <td>Testicular Germ Cell Tumors</td>
                  </tr>
                  <tr>
                    <td>TCGA-THCA</td>
                    <td>Thyroid Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-THYM</td>
                    <td>Thymoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-UCEC</td>
                    <td>Uterine Corpus Endometrial Carcinoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-UCS</td>
                    <td>Uterine Carcinosarcoma</td>
                  </tr>
                  <tr>
                    <td>TCGA-UVM</td>
                    <td>Uveal Melanoma</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>

    <v-row dense
           class="mt-n4 mx-16">
      <v-col cols="12">
        <v-expansion-panels class="data-table-style">
          <v-expansion-panel>
            <v-expansion-panel-header expand-icon="mdi-menu-down"
                                      style="padding: 10px 25px">
              <div class="d-flex font-weight-bold">
                <span class="blue--text font-weight-bold mt-1">Display Columns</span>
                <v-chip outlined
                        small
                        color="success"
                        class="ml-2"
                        @click="showAll()">
                  Select All
                </v-chip>
                <v-chip outlined
                        small
                        color="error"
                        class="ml-2"
                        @click="showDefault()">
                  Select Default
                </v-chip>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <div class="v-item-group">
                <v-checkbox v-for="(header, index) in headers"
                            :key="index"
                            :label="header.text"
                            :value="header.text"
                            v-model="selectedHeader"
                            dense
                            class="mx-1"></v-checkbox>
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-data-table dense
                      class="data-table-style mt-1 v-step-1"
                      :headers="selectedHeaders"
                      :items="splice_datasets"
                      fixed-header
                      v-model="selectedEvent"
                      item-key="_id"
                      :search="search"
                      :loading="loading"
                      loading-text="Loading... Please wait"
                      no-data-text="There is no avaliable alternative splicing events."
                      hide-default-footer
                      :page.sync="currentPage"
                      :items-per-page="pageSize"
                      v-show="selectedHeaders && selectedHeaders.length > 0">
          <template v-slot:item="{ item }">
            <tr :class="selectedEvent && selectedEvent.indexOf(item.event_id) > -1 ? 'blue lighten-5' : ''"
                @click="rowClicked(item)"
                class="v-step-2"
                style="cursor:pointer">
              <td v-show="selectedHeader.indexOf('Source') > -1">{{item.source}}</td>
              <td v-show="selectedHeader.indexOf('BioProject') > -1">{{item.project_id}}</td>
              <td v-show="selectedHeader.indexOf('Gene Name') > -1">
                <a @click="goToGeneSearchResult(item.gene_name)">
                  <span class="font-weight-bold">{{item.gene_name}}</span>
                </a>
                <v-icon class="px-1"
                        color="red"
                        v-if="selectedEvent && selectedEvent.indexOf(item.event_id) > -1">mdi-check</v-icon>
              </td>
              <td v-show="selectedHeader.indexOf('Chr') > -1">{{item.chr}}</td>
              <td v-show="selectedHeader.indexOf('Strand') > -1">{{item.strand}}</td>
              <td v-show="selectedHeader.indexOf('Cancer Type') > -1">{{item.cancer_name}}</td>
              <td v-show="selectedHeader.indexOf('Primary Site') > -1">{{item.primary_site}}</td>
              <td v-show="selectedHeader.indexOf('AS Type') > -1">{{item.as_type}}</td>
              <td v-show="selectedHeader.indexOf('Event Coordinates') > -1">{{item.event_coordinates}}</td>
              <td v-show="selectedHeader.indexOf('Alt Coordinates') > -1">{{item.alt_coordinates}}</td>
              <td v-show="selectedHeader.indexOf('ORF') > -1">{{item.orf}}</td>
              <td v-show="selectedHeader.indexOf('Control') > -1">{{item.control}}</td>
              <td v-show="selectedHeader.indexOf('Control Size') > -1">{{item.control_size}}</td>
              <td v-show="selectedHeader.indexOf('Case') > -1">{{item.case}}</td>
              <td v-show="selectedHeader.indexOf('Case Size') > -1">{{item.case_size}}</td>
              <td v-show="selectedHeader.indexOf('Percent Samples') > -1">{{item.pct_samples}}</td>
              <td v-show="selectedHeader.indexOf('PSI Tumor') > -1"> {{item.tumor_psi}}</td>
              <td v-show="selectedHeader.indexOf('PSI Normal') > -1">{{item.normal_psi}}</td>
              <td v-show="selectedHeader.indexOf('Delta PSI') > -1">{{item.dpsi}}</td>
              <td v-show="selectedHeader.indexOf('P Value') > -1">{{item.pvalue}}</td>
              <td v-show="selectedHeader.indexOf('FDR') > -1">{{item.fdr}}</td>
              <td v-show="selectedHeader.indexOf('DASE') > -1">{{item.is_dase}}</td>
              <td v-show="selectedHeader.indexOf('Visualization') > -1">
                <v-btn @click="goToVisualiztion(item.gene_name, item.as_type, item.event_coordinates)"
                       color="info"
                       icon>
                  <v-icon>mdi-tune</v-icon>
                </v-btn>
              </td>
              <td v-show="selectedHeader.indexOf('Explorer') > -1">
                <v-btn @click="goToRegulationExplorer(item.gene_name, 'TCGA', item.project_id, item.event_id)"
                       color="grey"
                       icon
                       :disabled="item.source != 'TCGA' || item.as_type == 'Complex' || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
                  <svg class="icon"
                       aria-hidden="true"
                       v-if="item.source != 'TCGA' || item.as_type == 'Complex' || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
                    <use xlink:href="#icon-GridView-diable"></use>
                  </svg>
                  <svg class="icon"
                       aria-hidden="true"
                       v-else>
                    <use xlink:href="#icon-GridView-oncoprint"></use>
                  </svg>
                </v-btn>
              </td>
              <td v-show="selectedHeader.indexOf('Survival') > -1">
                <v-btn @click.stop="goToSurvival(item.gene_name, 'TCGA', item.project_id, item.event_id)"
                       color="info"
                       icon
                       :disabled="item.source != 'TCGA' || item.as_type == 'Complex' || !survival_project_items.includes(item.project_id) || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
                  <svg class="icon"
                       aria-hidden="true"
                       v-if="item.source != 'TCGA' || item.as_type == 'Complex' || !survival_project_items.includes(item.project_id) || item.pct_samples <= 0.3 || item.tumor_psi <= 0.1 || item.tumor_psi == 1">
                    <use xlink:href="#icon-linechart-diable"></use>
                  </svg>
                  <svg class="icon"
                       aria-hidden="true"
                       v-else>
                    <use xlink:href="#icon-linechart"></use>
                  </svg>
                </v-btn>
              </td>
            </tr>
          </template>
          <!-- header.pct_samples slot -->
          <template v-slot:[`header.pct_samples`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Percent of samples with PSI values</span>
            </v-tooltip>
          </template>
          <!-- header.dpsi slot -->
          <template v-slot:[`header.dpsi`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Delta PSI = PSI Tumor - PSI Normal</span>
            </v-tooltip>
          </template>
          <!-- header.pvalue slot -->
          <template v-slot:[`header.pvalue`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>p value in Wilcoxon test</span>
            </v-tooltip>
          </template>
          <!-- header.fdr slot -->
          <template v-slot:[`header.fdr`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>FDR value in Wilcoxon test</span>
            </v-tooltip>
          </template>
          <!-- header.is_dase slot -->
          <template v-slot:[`header.is_dase`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Differential Alternative Splicing Events</span><br>
              <span>Filter criteria: |Delta PSI| > 0.1 & FDR < 0.05</span>
            </v-tooltip>
          </template>
          <!-- header.regulatory_explorer slot -->
          <template v-slot:[`header.regulatory_explorer`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Splicing Regulatory Explorer</span>
            </v-tooltip>
          </template>

          <!-- header.survival slot -->
          <template v-slot:[`header.survival`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Survival Analysis</span>
            </v-tooltip>
          </template>
        </v-data-table>
        <div class="d-flex justify-center mt-1"
             style="max-height:50px"
             v-if="isShowPaginate">
          <span class="text-body-1 mt-3">Items per page</span>
          <v-select v-model="pageSize"
                    dense
                    outlined
                    :items="pageSizes"
                    class="pagesize-select mt-1 mx-2"
                    @input="handlePageSizeChange(pageSize)">
          </v-select>
          <span class="text-body-1 mt-3 mx-2">Total <span class="font-weight-bold info--text">{{totalItems}}</span>
            items </span>
          <v-pagination v-model="currentPage"
                        color="info"
                        :length="totalPages"
                        :total-visible="5"
                        class="mx-1"
                        @input="handlePageChange"
                        prev-icon="mdi-menu-left"
                        next-icon="mdi-menu-right">
          </v-pagination>
          <span class="text-body-1 mt-2 mx-2">Page</span>
          <v-text-field outlined
                        dense
                        v-model="whichPage"
                        type="number"
                        class="jump-select"
                        append-icon="">
          </v-text-field>
          <v-btn color=""
                 depressed
                 outlined
                 class="mx-2"
                 @click="jumpPage()">Jump</v-btn>
        </div>
      </v-col>

      <v-col cols="12"
             class="d-flex justify-center">
        <v-tooltip bottom>
          <template v-slot:activator="{on, attrs}">
            <v-btn color="info"
                   class="v-step-3"
                   rounded
                   outlined
                   @click="Go()"
                   v-preventReClick
                   v-bind="attrs"
                   v-on="on"
                   :loading="go_loading"
                   :disabled="splice_datasets.length == 0 || selectedEvent.length == 0">
              Go !
              <v-icon right
                      small>mdi-run-fast</v-icon>
            </v-btn>
          </template>
          <span>Change the selected event by clicking the row.</span>
        </v-tooltip>
      </v-col>

      <!-- <v-progress-circular v-show="splice_datasets && splice_datasets.length > 0 && isShowProgress"
                           :rotate="-90"
                           :size="80"
                           :width="10"
                           indeterminate
                           color="primary">
      </v-progress-circular> -->
      <v-col cols="12"
             class="mt-8"
             v-show="splice_datasets && splice_datasets.length > 0">
        <v-alert color="error"
                 text
                 dense
                 outlined
                 border="left"
                 elevation="1"
                 icon="mdi-information"
                 v-show="isShowNoPsiText">Sorry, there is no PSI values for this splicing event!
        </v-alert>
        <div id="stage-plot"
             class="d-flex justify-space-around"
             v-show="!isShowNoPsiText">
          <!-- {{imgURL1}} -->
          <!-- v-resize directive not work-->
          <!-- v-resize.quiet="{log:true}" -->
          <iframe :src="imgURL1"
                  frameborder="0"
                  scrolling="no"
                  id="stage-violin-plot"
                  name="main"
                  width="38%"
                  :height="height"
                  class="v-step-4">
          </iframe>
          <!-- <pdf :src="imgURL2"
                   ref="pdf"></pdf> -->
          <iframe :src="imgURL2"
                  frameborder="0"
                  scrolling="no"
                  id="stage-survival-plot"
                  name="main"
                  width="44%"
                  :height="height"
                  class="v-step-5">
          </iframe>
        </div>
      </v-col>
    </v-row>
    <!-- </v-card> -->

    <!-- User guide -->
    <v-tooltip left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="guide-btn-style primary"
               fab
               small
               icon
               v-bind="attrs"
               v-on="on"
               @click="$tours['myTour'].start()">
          <v-icon color="white">mdi-book-cog</v-icon>
        </v-btn>
      </template>
      <span>User Guide</span>
    </v-tooltip>

    <v-tour name="myTour"
            :steps="steps"
            :options="{ highlight: true }"></v-tour>

    <!-- back to top -->
    <back-to-top></back-to-top>
  </v-container>
</template>

<script>
import { getSpliceDatasets, getAllProjectByGene } from 'node/browse.js';
// import { getAllGeneNamesFromGeneInfo } from 'node/general';
import { getAllGeneFromSpliceDataset } from 'node/browse';
import BackToTop from '@/components/main/BackToTop';
// import { findPSIByEventAndCancer } from 'node/splice_regulation_explorer';
// import { performStagingAnalysis, performSurvivalAnalysis } from 'node/stage_survival_analysis';
// import pdf from 'vue-pdf';

export default {
  name: 'StagePlot',
  components: {
    // pdf,
    BackToTop
  },
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Toolkit',
          disabled: false,
          href: '/ascancer/tools',
        },
        {
          text: 'Cancer Staging Analysis',
          disabled: true,
        },
      ],

      steps: [{
        target: '.v-step-0',
        content: `1. Input the <span class='font-weight-bold info--text'>Gene Name</span> and <span class='font-weight-bold info--text'>TCGA Project ID</span> !`,
        params: {
          placement: 'bottom',
          enableScrolling: false
        }
      },
      {
        target: '.v-step-1',
        content: `2. Show the <span class='font-weight-bold info--text'>filtered splicing events</span> based on the selected Gene Name and TCGA Project ID!<br/>`,
        params: {
          enableScrolling: false
        }
      },
      {
        target: '.v-step-2',
        content: `3. The <span class="font-weight-bold info--text"  style="color:#E3F2FD">blue background</span> in the table represents the currently selected splicing event.
        The first row is choosed by default. You can click on any row to switch the selected event.`,
        params: {
          enableScrolling: false
        }
      },
      {
        target: '.v-step-3',
        content: `4. Submit the selected splicing event to perform cancer staging analysis.`,
        params: {
          enableScrolling: false
        }
      },
      {
        target: '.v-step-4',
        content: `5. Show the distribution difference of PSI values 
        between different cancer pathological stages.`,
        params: {
          enableScrolling: false
        }
      },
      {
        target: '.v-step-5',
        content: `6. Show the survival difference of the selected splicing event between different cancer pathological stages.`,
        params: {
          enableScrolling: false
        }
      }],

      search: '',
      loading: true,
      currentPage: 1,
      whichPage: 1,
      totalPages: 0,
      pageSize: 5,
      pageSizes: [5, 10, 15, 20, 50, 100],
      totalItems: 0,
      isShowPaginate: true,

      selectedHeader: ['Gene Name', 'Cancer Type', 'AS Type',
        'Event Coordinates', 'ORF', 'PSI Tumor', 'PSI Normal', 'Delta PSI', 'FDR',
        'DASE', 'Visualization', 'Explorer', 'Survival'],
      headers: [
        { text: 'Source', value: 'source', align: 'start', sortable: false, },
        { text: 'BioProject', value: 'project_id', align: 'start', sortable: false, },
        { text: 'Gene Name', value: 'gene_name', align: 'start', sortable: true, },
        { text: 'Chr', value: 'chr', align: 'start', sortable: true, },
        { text: 'Strand', value: 'strand', align: 'start', sortable: true, },
        { text: 'Cancer Type', value: 'cancer_name', align: 'start', sortable: true },
        { text: 'Primary Site', value: 'tissue', align: 'start' },
        { text: 'AS Type', value: 'as_type', align: 'start' },
        { text: 'Event Coordinates', value: 'event_coordinates', align: 'start', },
        { text: 'Alt Coordinates', value: 'alt_coordinates', align: 'start', sortable: false, },
        { text: 'ORF', value: 'orf', align: 'start', sortable: false, },
        { text: 'Control', value: 'control', align: 'start', sortable: true, },
        { text: 'Control Size', value: 'control_size', align: 'start', sortable: false, },
        { text: 'Case', value: 'case', align: 'start', sortable: false, },
        { text: 'Case Size', value: 'case_size', align: 'start', sortable: false, },
        { text: 'Percent Samples', value: 'pct_samples', align: 'start', sortable: false, },
        { text: 'PSI Tumor', value: 'tumor_psi', align: 'start', sortable: false, },
        { text: 'PSI Normal', value: 'normal_psi', align: 'start', sortable: false, },
        { text: 'Delta PSI', value: 'dpsi', align: 'start', sortable: false, },
        { text: 'P Value', value: 'pvalue', align: 'start', sortable: false, },
        { text: 'FDR', value: 'fdr', align: 'start', sortable: false, },
        { text: 'DASE', value: 'is_dase', align: 'start', sortable: false, },
        { text: 'Visualization', value: 'visualization', align: 'start', sortable: false, },
        { text: 'Explorer', value: 'regulatory_explorer', align: 'start', sortable: false, },
        { text: 'Survival', value: 'survival', align: 'start', sortable: false, },
      ],
      splice_datasets: [],

      selectedEvent: [],
      routeEvent: null,

      gene_select: null,
      gene_search: null,
      gene_list: [],
      gene_items: [],
      gene_loading: false,
      gene_message: null,
      gene_error_message: null,
      is_disable_gene: false,

      source_select: "TCGA",

      project_select: null,
      // project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CESC", "TCGA-CHOL",
      //   "TCGA-COAD", "TCGA-DLBC", "TCGA-ESCA", "TCGA-GBM", "TCGA-HNSC", "TCGA-KICH",
      //   "TCGA-KIRC", "TCGA-KIRP", "TCGA-LAML", "TCGA-LGG", "TCGA-LIHC", "TCGA-LUAD",
      //   "TCGA-LUSC", "TCGA-MESO", "TCGA-OV", "TCGA-PAAD", "TCGA-PCPG", "TCGA-PRAD",
      //   "TCGA-READ", "TCGA-SARC", "TCGA-SKCM", "TCGA-STAD", "TCGA-TGCT", "TCGA-THCA",
      //   "TCGA-THYM", "TCGA-UCEC", "TCGA-UCS", "TCGA-UVM",
      // ],
      project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-ESCA", "TCGA-HNSC", "TCGA-KICH", "TCGA-KIRC", "TCGA-KIRP",
        "TCGA-LUAD", "TCGA-LUSC", "TCGA-MESO", "TCGA-PAAD", "TCGA-READ", "TCGA-SKCM",
        "TCGA-STAD", "TCGA-THCA",
      ],// 隐藏 TCGA-LAML
      survival_project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CESC", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-DLBC", "TCGA-ESCA", "TCGA-GBM", "TCGA-HNSC", "TCGA-KICH",
        "TCGA-KIRC", "TCGA-KIRP", "TCGA-LAML", "TCGA-LGG", "TCGA-LUAD", "TCGA-LUSC", "TCGA-MESO",
        "TCGA-OV", "TCGA-PAAD", "TCGA-PCPG", "TCGA-PRAD", "TCGA-READ", "TCGA-SARC",
        "TCGA-SKCM", "TCGA-STAD", "TCGA-THCA", "TCGA-THYM", "TCGA-UCEC", "TCGA-UCS", "TCGA-UVM",
      ],
      project_error_message: null,
      dialog: false,
      is_disable_project: false,

      isShowNoPsiText: false,
      isShowProgress: false,
      progress: 10,

      majorSatge: true,
      imgURL1: "",
      imgURL2: "",
      height: 0,

      go_loading: false,
    }
  },
  created() {
    // this.getAllGeneFromSpliceDataset().then(() => {
    if (JSON.stringify(this.$route.query) === '{}') {
      // console.log('query is null');
      this.source_select = "TCGA";
      this.gene_select = "EZH2";
      this.project_select = "TCGA-READ";
      this.changeRoute();

    } else if (Object.keys(this.$route.query).includes('eventid')) {
      if (this.$route.query.genename) {
        this.gene_select = this.$route.query.genename;
      } else {
        // window.alert('Please enter the Gene Name !')
        this.gene_error_message = "Please enter the Gene Name !";
      }
      if (this.$route.query.source) {
        this.source_select = "TCGA";
      }
      if (this.project_items.includes(this.$route.query.project)) {
        this.project_select = this.$route.query.project;
      } else {
        // window.alert('Please enter the TCGA Project ID !')
        this.project_error_message = "Please select the TCGA Project ID !"
      }

      this.routeEvent = this.$route.query.eventid;

    } else if (JSON.stringify(this.$route.query) !== '{}') {
      if (this.$route.query.genename) {
        this.gene_select = this.$route.query.genename;
      } else {
        // window.alert('Please enter the Gene Name !')
        this.gene_error_message = "Please enter the Gene Name !"
      }
      if (this.$route.query.source) {
        this.source_select = "TCGA";
      }
      if (this.project_items.includes(this.$route.query.project)) {
        this.project_select = this.$route.query.project;
      } else {
        // window.alert('Please enter the TCGA Project ID !')
        this.project_error_message = "Please select the TCGA Project ID !"
      }
    }
    // });
  },
  mounted() {
    this.getAllGeneFromSpliceDataset();

    // this.watchIframe();

    // var _this = this;
    // const iframe = document.querySelector('#stage-violin-plot');
    // // 处理兼容行问题
    // if (iframe.attachEvent) {
    //   iframe.attachEvent('onload', function () {
    //     // iframe加载完毕以后执行操作
    //     console.log('iframe已加载完毕')
    //   })
    // } else {
    //   iframe.onload = function () {
    //     // iframe加载完毕以后执行操作
    //     console.log('iframe已加载完毕')
    //   }
    // }
  },
  computed: {
    selectedHeaders() {
      return this.headers.filter(h => this.selectedHeader.includes(h.text))
    },
    // watch multi data props meanwhile.
    listenMultiData() {
      const { gene_select, source_select, project_select } = this;
      return {
        gene_select, source_select, project_select
      }
    },
  },
  watch: {
    imgURL1() {
      this.height = 660;
    },
    splice_datasets(val) {
      if (val) {
        this.loading = false;
      }
    },
    gene_search(val) {
      val && val !== this.gene_select && this.querySelections(val)
    },
    gene_select(val) {
      // console.log(val);
      if (val == this.$route.query.genename) {
        this.gene_select = val;
        this.gene_message = null;
        this.gene_error_message = null;
        this.currentPage = 1; // default show the first page
        this.whichPage = 1;

        this.selectedEvent = [];
        this.changeRoute();
        // this.getAllProjectByGene(); // find All Project By Gene
      } else if (val == null || val == "") {
        this.gene_message = "Please enter the Gene Name."
      } else if (val && this.gene_list.includes(val)) {
        this.gene_select = val;
        this.gene_message = null;
        this.gene_error_message = null;
        this.currentPage = 1; // default show the first page
        this.whichPage = 1;

        this.selectedEvent = [];
        this.changeRoute();
        // this.getAllProjectByGene(); // find All Project By Gene
      } else {
        // window.alert("Sorry, we cant' find this gene.");
        this.gene_select = null;
      };
    },
    project_select(val) {
      if (val && this.project_items.includes(val)) {
        this.project_select = val;
        this.project_error_message = null;
        this.currentPage = 1; // default show the first page
        this.whichPage = 1;

        this.selectedEvent = [];
        this.changeRoute();
      }
    },
    listenMultiData(val) {
      if (val.gene_select && val.source_select && val.project_select) {
        this.getSpliceDatasets().then(() => {

          // default select the first
          if (this.gene_select == "EZH2" && this.project_select == "TCGA-READ") {
            // console.log('hahaha');
            this.initFirstEvent();
          }

          if (this.routeEvent) {
            this.selectedEvent.push(this.routeEvent);
          }
        });
      }
    },
    go_loading(val) {
      if (val == true) {
        this.is_disable_gene = true;
        this.is_disable_project = true;
      } else {
        this.is_disable_gene = false;
        this.is_disable_project = false;
      }
    },
  },
  methods: {
    // async getAllGeneNamesFromGeneInfo() {
    //   await getAllGeneNamesFromGeneInfo().then(data => {
    //     // console.log(data);
    //     if (data) {
    //       this.gene_list = data;
    //     }
    //   }).catch(err => console.error(err))
    // },
    async getAllGeneFromSpliceDataset() {
      await getAllGeneFromSpliceDataset().then(data => {
        // console.log(data);
        if (data) {
          this.gene_list = data;
          this.exp_scatter_gene_list = data;
        }
      }).catch(err => console.error(err))
    },
    querySelections(v) {
      this.gene_message = null;
      this.gene_error_message = null;
      this.gene_loading = true;
      setTimeout(() => {
        this.gene_items = this.gene_list.filter(e => {
          let pattern = new RegExp(v, 'ig');
          return pattern.test(e);
        })
        this.gene_loading = false
        // show the no data tips when the gene_search result is null
        if (this.gene_items.length == 0) {
          this.gene_error_message = "Sorry, we cant' find this gene.";
        }
      }, 500)
    },
    getRequestParams(genename, source, project, page, pageSize) {
      let params = {};

      if (genename) {
        params["genename"] = genename;
      }

      if (source) {
        params["source"] = source;
      }

      if (project) {
        params["project"] = project;
      }

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      return params;
    },
    async getSpliceDatasets(size) {

      // Handle page size change
      // if (size) {
      //   // console.log(size);
      //   this.pageSize = size;
      // } else if (this.project_select == "TCGA-READ") {
      //   this.pageSize = 300;
      // } else {
      //   this.pageSize = 5;
      // }

      this.pageSize = 300;

      const params = this.getRequestParams(
        this.gene_select,
        this.source_select,
        this.project_select,
        this.currentPage,
        this.pageSize
      );
      await getSpliceDatasets(params).then(
        data => {

          if (data) {
            // console.log(data);
            // this.totalItems = data.totalItems;
            // this.splice_datasets = data.items;
            // this.currentPage = data.currentPage;
            // this.totalPages = data.totalPages;

            let items = data.items;

            if (items.length > 0) {

              items = items.filter(d => d.tumor_psi > 0);

              // move the second event to the first one.
              if (this.gene_select == "EZH2" && this.project_select == "TCGA-READ") {
                this.isShowPaginate = false;
                let items = data.items;
                // move the second event to the first one.
                let ezh2_9b = items.splice(1, 1);
                // console.log(ezh2_9b);
                items.unshift(ezh2_9b[0])
                this.splice_datasets = items;
              } else {
                this.isShowPaginate = false;
                this.splice_datasets = items;
              }
            } else {
              this.splice_datasets = [];
            }

            // refresh the selectedEvent
            if (this.selectedEvent.length > 0) {
              this.selectedEvent = [];
            }
          }
        }
      ).catch(err => console.error(err))
    },
    // async getAllProjectByGene() {
    //   let genename = this.gene_select;
    //   await getAllProjectByGene(genename).then(data => {
    //     if (data) {
    //       // console.log(data);
    //       data = data.filter(d => { return d != "TCGA-LAML" && d != "TCGA-DLBC" })
    //       this.project_items = data;
    //     }
    //   }).catch(err => {
    //     console.error(err);
    //   })
    // },
    initFirstEvent() {
      // select the first event defaultly
      let item = this.splice_datasets && this.splice_datasets[0];
      // console.log(item);
      if (item) {
        this.selectedEvent[0] = item && item.event_id;
        this.Go();
      }
    },
    rowClicked(item) {

      if (this.selectedEvent[0] !== item.event_id) {

        this.selectedEvent = []; // first empty the array
        this.selectedEvent.push(item.event_id);

        // this.isShowProgress = true;
        // this.plot();
      }
    },
    Go() {

      this.changeRoute(); // change the route (add eventid) when run Go!

      this.go_loading = true; // start go loading
      this.isShowProgress = true;
      this.plot();
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.whichPage = this.currentPage;
      this.getSpliceDatasets();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getSpliceDatasets(size);
    },
    jumpPage() {
      // console.log(+this.whichPage);
      if (+this.whichPage < 1) {
        this.whichPage = 1;
      }
      if (+this.whichPage > this.totalPages) {
        this.whichPage = this.totalPages;
      }
      this.currentPage = +this.whichPage;
      this.getSpliceDatasets();
    },
    watchIframe() {
      let iframe = document.getElementById('stage-violin-plot').contentWindow;
      // console.log(iframe.document.getElementById('mainContainer'));
      let container = iframe.document.getElementById('mainContainer'); // watch mainContainer
      if (container == null) {
        setTimeout(this.watchIframe, 1000);
      } else {
        this.isShowProgress = false;
      }
    },
    plot() {

      this.isShowProgress = true;

      this.imgURL1 = "https://ngdc.cncb.ac.cn/ascancer/stage/asevent?projectid=" +
        this.project_select + "&eventid=" +
        encodeURIComponent(this.selectedEvent) + "&major=" +
        this.majorSatge;
      // encodeURIComponent (防止加号变空格)
      // this.imgURL1 = "http://localhost:9200/ascancer/stage/asevent?projectid=" +
      //   this.project_select + "&eventid=" +
      //   encodeURIComponent(this.selectedEvent) + "&major=" +
      //   this.majorSatge;
      // console.log(this.imgURL1);

      this.imgURL2 = "https://ngdc.cncb.ac.cn/ascancer/stage-survival/asevent?projectid=" +
        this.project_select + "&eventid=" +
        encodeURIComponent(this.selectedEvent) + "&major=" +
        this.majorSatge;
      // this.imgURL2 = "http://localhost:9200/ascancer/stage-survival/asevent?projectid=" +
      //   this.project_select + "&eventid=" +
      //   encodeURIComponent(this.selectedEvent) + "&major=" +
      //   this.majorSatge;

      // console.log(this.progress);
      // setInterval(() => {
      //   this.progress = this.progress + 15;
      // }, 500);

      setTimeout(() => {
        this.isShowProgress = false;
        this.go_loading = false;
      }, 4000);
    },
    changeRoute() {
      // console.log('go');
      this.$router.replace({
        path: '/tools/stage/asevent',
        query: {
          genename: this.gene_select,
          source: this.source_select,
          project: this.project_select,
          eventid: this.selectedEvent[0],
        }
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          console.error(err);
        }
      });
    },
    goToGeneSearchResult(genename) {
      if (genename) {
        this.$router.push({
          path: '/search',
          query: {
            genename: genename,
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      } else if (genename == null || genename == '') {
        window.alert("Sorry, please input the gene name !")
      }
    },
    goToVisualiztion(genename, astype, coordinate) {
      this.$router.push({
        path: '/splicevis',
        query: {
          genename: genename,
          astype: astype,
          coordinate: coordinate
        }
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    goToRegulationExplorer(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/regexp',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    goToSurvival(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/survival/asevent',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    showAll() {
      this.headers.map(h => {
        this.selectedHeader.push(h.text)
      })
    },
    showNone() {
      this.selectedHeader = [];
    },
    showDefault() {
      this.selectedHeader = ['Gene Name', 'Cancer Type', 'AS Type',
        'Event Coordinates', 'ORF', 'PSI Tumor', 'PSI Normal', 'Delta PSI', 'FDR',
        'DASE', 'Visualization', 'Explorer', 'Survival'];
    }
  }
}
</script>
<style scoped lang="sass">
a
  text-decoration: none
  color: #2196F3

a:hover
  text-decoration: underline

.v-data-table ::v-deep th
  font-size: 0.87rem !important
.v-data-table ::v-deep td
  font-size: 0.875rem !important

.v-btn
  text-transform: none
  letter-spacing: 0em
  font-size: 0.875rem

.v-sheet.v-card
  border-radius: 15px

.v-card__title
  line-height: 0.5rem

.breadcrumb
  line-height: 1
  display: inline-block
  margin: 0 0
  vertical-align: middle
  padding: 8px 15px
  margin-top: -5px
  margin-bottom: 10px
  list-style: none
  background-color: #f5f5f5
  border-radius: 4px

.data-table-style
  border: thin solid rgba(0, 0, 0, 0.12)

.v-item-group
  flex: 0 1 auto
  position: relative
  display: inline-flex
  flex-wrap: wrap
  max-width: 100%
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)

.pagesize-select
  max-width: 6%

.jump-select
  max-width: 6%

.v-progress-circular
  margin: 1rem
  left: 45%

#stage-violin-plot
  margin-right: 2%

.v-input--selection-controls
  margin-top: 2px
  padding-top: 0px

// set the width of guide
::v-deep .v-step
  max-width: 600px
  text-align: start

// set the style of highlight
.v-tour__target--highlighted
  border: 1px red solid
  border-radius: 0.8rem
  box-shadow: 0 0 0 99999px rgba(0,0,0,.4)

.guide-btn-style
  position: fixed
  right: 1%
  top: 90%
  transform: translateY(-50%)
  z-index: 99
</style>